import React, { useState } from 'react';
import LeftMenu from './Sections/LeftMenu';
import RightMenu from './Sections/RightMenu';
import { Drawer, Button } from 'antd';
import './Sections/Navbar.css';
import { useHistory } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons'

function NavBar(props) {
  const [visible, setVisible] = useState(false)
  const history = useHistory();
  const state = props?.location?.state;

  const showDrawer = () => {
    setVisible(true)
  };

  const onClose = () => {
    setVisible(false)
  };

  return (
    <nav className="menu" style={{ position: 'fixed', top: '0px', zIndex: 5, width: '100%' }}>

      {props.isRoot ?
        <div className="menu__logo">
          <a href="/">{process.env.REACT_APP_TITLE}</a>
        </div>
        :
        <>
          <Button icon={<ArrowLeftOutlined />} onClick={() => {
            const urlBefore = window.location.href;
            history?.goBack();
            setTimeout(() => {
              const urlAfter = window.location.href;
              if (urlAfter === urlBefore) {
                alert(`urlBefore:${urlBefore}, urlAfter:${urlAfter}`);
                history.push('/');
              }
            }, 100);
          }} type='link' />
          <label style={{ flex: 1, fontWeight: 'bold' }}>{state?.title}</label>
        </>
      }

      <div className="menu__container">
        {/* <div className="menu_left">
          <LeftMenu mode="horizontal" />
        </div>
        <div className="menu_rigth">
          <RightMenu mode="horizontal" />
        </div> 
        <Button
          className="menu__mobile-button"
          type="primary"
          // onClick={showDrawer}
          ></Button>
        */}

        {window.location.href.includes('/profile') ?
          <Button
            className="menu__mobile-button"
            type="primary"
            onClick={() => { history.push(`/others`) }}
          >
            설정
          </Button>
          :
          window.location.href.split('/').pop() == '' &&
          <Button
            className="menu__mobile-button"
            type="primary"
            onClick={() => { history.push(`/product/upload`) }}
          >
            등록
          </Button>
        }

        <Drawer
          title="Drawer"
          placement="right"
          className="menu_drawer"
          closable={false}
          onClose={onClose}
          visible={visible}
        >
          {/* <LeftMenu mode="inline" /> */}
          <RightMenu mode="inline" />
        </Drawer>

      </div>

    </nav>
  )
}

export default NavBar